import { useLocation } from "react-router-dom";
import { EstimatedTaxDashboardBody } from "./EstimatedTaxDashboardBody";

const titleFromPath = (pathname: string): string => {
  if (pathname.endsWith("/breakdown")) return "Monthly Breakdown";
  if (pathname.endsWith("/tax-benefits")) return "Tax benefits";
  if (pathname.endsWith("/settings")) return "Settings";
  return "Overview";
};

export const AdvanceTaxAndProfitsDashboardCustomer = () => {
  const { pathname } = useLocation();

  return (
    <EstimatedTaxDashboardBody
      title={titleFromPath(pathname)}
      containerClassName="t-px-5"
    />
  );
};
